<template>
<main class="details card" v-bind:class="{enabled: form.enabled}">

  <header>
    <check-circle-icon v-if="form.enabled" class="icon status" ></check-circle-icon>
    <x-circle-icon v-else class="icon status" ></x-circle-icon>
    <span>
      <h1>{{form.name}}</h1>
      <h2>{{form.domain}}</h2>
    </span>
    <div class="entries-info">
      <div class="accepted"><message-square-icon/>{{form.entriesCount.notifications}}</div>
      <div v-if="form.entriesCount.total !== form.entriesCount.notifications"  class="rejected">
        <alert-triangle-icon/>{{form.entriesCount.total - form.entriesCount.notifications}}
      </div>
    </div>
  </header>

  <div v-if="!form.enabled" class="disabled">
    <div>
      <strong>This form is disabled.</strong>
      <p>
        Incoming <span>messages will not be saved</span> and
        <span>notifications will not be sent</span>.
      </p>
      <p>Users will see a notice asking them to submit again at a later date.</p>
    </div>
    <a id="enabled" @click="enableForm">
      <label v-if="form.enabled">Form Enabled</label>
      <label v-else>Enable Form</label>
    </a>
  </div>
  <section>
    <ul>
      <li>
        <div class="icon-box"><calendar-icon/></div>
        <span><small>Created</small><p>{{timeAbsolute(form.created_at)}}</p></span>
      </li>
      <li>
        <div class="icon-box"><mail-icon/></div>
        <span>
          <small>Recipients</small>
          <p class="pill" v-for="(recipient, index) in form.recipients" :key="index">
            {{recipient.address}}
          </p>
        </span>
      </li>
    </ul>
    <ul>
      <li v-if="form.extraSpamCheck">
        <div class="icon-box"><shield-icon/></div>
        <span><small>Additional AntiSpam</small><p>Enabled</p></span>
      </li>
      <li v-else>
        <div class="icon-box"><shield-off-icon/></div>
        <span><small>Additional AntiSpam</small><p>Disabled</p></span>
      </li>
      <li>
        <div class="icon-box"><file-icon/></div>
        <span><small>Attachments</small>
          <p v-if="form.allowFileUploads">Enabled</p>
          <p v-else>Disabled</p>
        </span>
      </li>
      <li>
        <div class="icon-box"><external-link-icon/></div>
        <span><small>Redirect</small>
          <p v-if="form.redirect">{{form.redirect}}</p>
          <p v-else>/thanks</p>
        </span>
      </li>
    </ul>
  </section>

</main>
</template>

<script>
import FormsService from '@/services/Forms';
import dayjs from 'dayjs';

import {
  CheckCircleIcon, XCircleIcon, MessageSquareIcon,
  CalendarIcon, MailIcon, ShieldIcon, ShieldOffIcon, FileIcon, ExternalLinkIcon, AlertTriangleIcon,
} from 'vue-feather-icons';

export default {
  props: ['form'],
  data() {
    return {
    };
  },
  methods: {
    async enableForm() {
      const form = { id: this.form.id, enabled: true };
      await FormsService.editForm(form).then((response) => {
        if (response.status === 200) this.$emit('updated', response.data);
      }).catch((e) => { this.error = e.response.data.error; });
    },
    timeAbsolute(string) {
      return dayjs(string).format('MMMM D, YYYY');
    },
  },
  components: {
    CheckCircleIcon,
    XCircleIcon,
    MessageSquareIcon,
    CalendarIcon,
    MailIcon,
    ShieldIcon,
    ShieldOffIcon,
    FileIcon,
    ExternalLinkIcon,
    AlertTriangleIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  main {
    border-top: 10px solid var(--red);
    padding: 30px;
  }

  main.enabled {
    border-color: var(--green);
  }

  header {
    display: flex;
    align-items: center;
    padding-bottom: 2em;
    border-bottom: 1px solid #444;

  }

  header .status {
    width: 40px;
    height: 40px;
    margin-right: 30px;
  }

  header h1, h2 {
    margin: 0;
    padding: 0;
    font-weight: 400;
  }

  header h1 {
    font-size: 2.3em;
  }

  header h2 {
    margin-top: -5px;
    font-size: 1.2em;
    color: #555;
  }

  header .entries-info {
    font-size: 2em;
    position: relative;
    text-align: center;
    margin-left: auto;
    padding-right: 30px;
    padding-bottom: 20px;
    display: flex;
  }

  header .entries-info div {
    padding-left: 15px;
    position: relative;
  }

  header .entries-info div svg {
    margin-right: 5px;
  }

  header .entries-info div:not(:last-of-type){
    margin-right: 35px;
  }

  header .entries-info div:before {
    position: absolute;
    font-size: 0.5em;
    bottom: -15px;
    right: 0;
  }

  header .entries-info .accepted:before { content: 'ACCEPTED'; }
  header .entries-info .rejected:before { content: 'REJECTED'; }

  .icon.feather-check-circle { color: var(--green); }
  .icon.feather-x-circle { color: var(--red); }

  .details .disabled {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    align-items: center;
    line-height: 1.5em;
    padding: 15px 30px;
    background: var(--yellow);
    border-radius: 0 0 10px 10px;
  }

  .details .disabled p {
    color: hsl(0, 0%, 30%);
    margin:0; padding:0;
  }

  .details .disabled a {
    border: 1px solid black;
    padding: 5px 15px;
    margin-bottom: 20px;
    border-radius: 5px;
    text-decoration: none;
    text-transform: uppercase;
    cursor: pointer;
  }

  .details .disabled a:hover {
    background: var(--yellow-dark);
  }

  .details .disabled span {
    border-bottom: 0.5px solid #444;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-around; */
  }

  section ul { margin: 0; }

  section ul:first-of-type {
    padding-right: 50px;
  }

  section li {
    display: flex;
    list-style-type: none;
    align-content: center;
    margin-top: 40px;
  }

  section li .icon-box {
    display: inline-flex;
    padding: 15px;
    border-radius: 50%;
    background: var(--black);
    color: white;
    align-self: flex-start;
  }

  section li span {
    padding-left: 15px;
    align-self: center;
    display: flex;
    flex-direction: column;
  }

  section li span small {
    text-transform: uppercase;
    font-size: 1em;
    color: #444;
  }

  section li span p {
    font-size: 1.1em;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }

  section li span p.pill {
    margin-top: 5px;
    font-size: 1em;
    background: lightgray;
    border-radius: 30px;
    padding: 5px 15px;
  }

  section li span.inline {
    flex-direction: row;
  }

  section li span.inline p {
    display: inline;
  }

</style>
